import { Box, CircularProgress } from "@mui/material";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useHandleSignInCallback } from "@logto/react";

import { useGlobalStore } from "controller";
const refreshBroadcast = new BroadcastChannel("refresh_channel");
export const AuthValidator = () => {
  const navigate = useNavigate();

  const { isLoading, error } = useHandleSignInCallback(() => {
    // Navigate to root path when finished
    navigate("/app/home");
  });

  useEffect(() => {
    if (error && !isLoading) {
      navigate("/login");
    }
  }, [error, isLoading]);

  // When it's working in progress
  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return null;
};
